<template>
  <section class="section">
    <div class="container sub">
      <div>
        <p class="eyebrow">{{ t("subscription.eyebrow") }}</p>
        <h2 class="section-title">{{ t("subscription.title") }}</h2>
        <p class="section-lead">{{ t("subscription.lead") }}</p>
        <ul>
          <li v-for="(point, index) in points" :key="index">
            <svg class="check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
              <path d="M20 6 9 17l-5-5" />
            </svg>
            <span>{{ point }}</span>
          </li>
        </ul>
        <p class="sub__price">
          {{ t("subscription.priceDisplay") }}
        </p>
        <a class="btn btn--primary" :href="quoteHref" target="_blank" rel="noopener">
          {{ t("subscription.cta") }} <span aria-hidden="true">→</span>
        </a>
        <p class="note">{{ t("subscription.note") }}</p>
      </div>
      <div class="sub__panel" aria-hidden="true">
        <div class="sub__thumbs">
          <div class="thumb"></div>
          <div class="thumb"></div>
          <div class="thumb"></div>
          <div class="thumb"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { whatsappHref } from "@/data/company";

export default {
  name: "SubscriptionSection",
  setup() {
    const { t } = useI18n();
    const quoteHref = computed(() => whatsappHref(t("contact.waPrefill")));
    const points = computed(() => {
      const list = [];
      for (let i = 0; i < 8; i += 1) {
        const key = `subscription.points.${i}`;
        const value = t(key);
        if (value === key) break;
        list.push(value);
      }
      return list;
    });
    return { t, quoteHref, points };
  },
};
</script>
